import React from "react";
import { Badge, Button, Empty, Typography, Flex, Tooltip } from "antd";
import { FileAddOutlined, PlusOutlined } from "@ant-design/icons";
import EditableLabel from "../../../../../ui/EditableLabel";
import {
  MAX_FORMS_PER_MODE,
  sanitizeFormName,
} from "../../../../../../domain/clinicalForms";
import {
  isIaForm,
  isReviewForm,
} from "../../../../../../mappers/clinicalForms.mappers";

const isLockedForm = (form) =>
  !!form?.system || isIaForm(form) || isReviewForm(form);

const activeTabStyle = {
  padding: "10px 18px",
  border: "1px solid #d0d5dd",
  borderBottom: "none",
  borderRadius: "8px 8px 0 0",
  background: "#ffffff",
  fontWeight: 600,
  color: "#101828",
  marginBottom: -1,
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
};

const FormTabs = ({
  forms,
  activeId,
  onSelect,
  onAdd,
  canAdd = true,
  onRename,
  renderContent,
}) => {
  const activeForm = forms.find((f) => f.id === activeId) || forms[0];

  return (
    <Flex vertical>
      <Flex
        align="center"
        gap={20}
        style={{ padding: "12px 16px 0", background: "#ffffff", zIndex: 1 }}
      >
        {forms.map((form) => {
          const isActive = form.id === activeForm?.id;
          if (isActive) {
            const locked = isLockedForm(form);
            return (
              <div key={form.id} style={activeTabStyle}>
                <EditableLabel
                  value={form.name}
                  editable={!locked}
                  showIcon={!locked}
                  sanitize={sanitizeFormName}
                  onChange={(name) => onRename?.(form.id, name)}
                />
                {form.active === false && <Badge status="error" />}
              </div>
            );
          }
          return (
            <Typography.Text
              key={form.id}
              type="secondary"
              onClick={() => onSelect(form.id)}
              style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}
            >
              {form.name}
              {form.active === false && <Badge status="error" />}
            </Typography.Text>
          );
        })}
        <Tooltip
          title={
            canAdd
              ? null
              : `Up to ${MAX_FORMS_PER_MODE} forms per mode`
          }
        >
          <Button
            type="text"
            icon={<PlusOutlined />}
            onClick={onAdd}
            disabled={!canAdd}
          >
            Add New form
          </Button>
        </Tooltip>
      </Flex>

      {activeForm ? (
        <div
          style={{
            borderTop: "1px solid #d0d5dd",
            background: "#ffffff",
            padding: 20,
          }}
        >
          {renderContent?.(activeForm)}
        </div>
      ) : (
        <div style={{ padding: "48px 0" }}>
          <Empty
            image={<FileAddOutlined style={{ fontSize: 44, color: "#d0d5dd" }} />}
            imageStyle={{ height: 56 }}
            description={
              <div>
                <Typography.Title level={5} style={{ margin: 0 }}>
                  No forms yet
                </Typography.Title>
                <Typography.Text type="secondary">
                  Add a form to start building fields for this mode.
                </Typography.Text>
              </div>
            }
          >
            <Tooltip
              title={canAdd ? null : `Up to ${MAX_FORMS_PER_MODE} forms per mode`}
            >
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={onAdd}
                disabled={!canAdd}
              >
                Add New form
              </Button>
            </Tooltip>
          </Empty>
        </div>
      )}
    </Flex>
  );
};

export default FormTabs;
